import { Controller } from "@hotwired/stimulus"

// Marks the clicked link as the current selection (aria-current="true") and
// clears it from its siblings, so the open mailbox / conversation stays visibly
// active across Turbo-Frame navigations that don't reload the surrounding pane.
export default class extends Controller {
  static targets = ["item"]

  select(event) {
    const chosen = event.currentTarget
    this.itemTargets.forEach((item) => item.removeAttribute("aria-current"))
    chosen.setAttribute("aria-current", "true")
  }
}
